// apps/web/src/components/ScannerViewfinder.tsx
// The barcode viewfinder both scanner sheets share (owner: "blur out the
// surroundings, only the barcode area is the camera"). Four backdrop-blur
// panels tile around a clear center window, so the live camera shows crisp
// ONLY where the barcode belongs; lime corner brackets mark the window and a
// torch button appears when (and only when) the device camera reports the
// capability.
import { Flashlight, FlashlightOff } from "lucide-react";
import { useT } from "../lib/i18n";

interface Props {
  hint: string;
  torchSupported: boolean;
  torchOn: boolean;
  onToggleTorch: () => void;
}

const DIM = "backdrop-blur-md bg-black/35";

export function ScannerViewfinder({ hint, torchSupported, torchOn, onToggleTorch }: Props) {
  const t = useT();
  return (
    <div className="pointer-events-none absolute inset-0 flex flex-col">
      <div className={`flex-1 ${DIM}`} />
      <div className="flex h-44">
        <div className={`flex-1 ${DIM}`} />
        {/* the clear window — the camera stays sharp only here */}
        <div className="relative w-72">
          <div className="absolute inset-0 rounded-2xl ring-1 ring-white/25" />
          {/* corner brackets */}
          <svg className="absolute inset-0 h-full w-full" viewBox="0 0 288 176" fill="none" aria-hidden="true">
            <path d="M6 30 V14 a8 8 0 0 1 8 -8 H30" stroke="#67d491" strokeWidth="4" strokeLinecap="round" />
            <path d="M258 6 h16 a8 8 0 0 1 8 8 v16" stroke="#67d491" strokeWidth="4" strokeLinecap="round" />
            <path d="M282 146 v16 a8 8 0 0 1 -8 8 h-16" stroke="#67d491" strokeWidth="4" strokeLinecap="round" />
            <path d="M30 170 H14 a8 8 0 0 1 -8 -8 v-16" stroke="#67d491" strokeWidth="4" strokeLinecap="round" />
          </svg>
        </div>
        <div className={`flex-1 ${DIM}`} />
      </div>
      <div className={`flex-1 ${DIM} flex flex-col items-center gap-4 pt-4`}>
        <p className="px-6 text-center text-sm text-white/85">{hint}</p>
        {torchSupported && (
          <button
            type="button"
            onClick={onToggleTorch}
            aria-label={t(torchOn ? "barcode.torch_off" : "barcode.torch_on")}
            aria-pressed={torchOn}
            className={`pointer-events-auto flex h-12 w-12 items-center justify-center rounded-full transition-colors ${
              torchOn ? "bg-brand text-black" : "bg-white/15 text-white"
            }`}
          >
            {torchOn ? <Flashlight size={22} /> : <FlashlightOff size={22} />}
          </button>
        )}
      </div>
    </div>
  );
}
